import FaveBizAPI from 'integrations/FaveBizAPI';

export default params =>
  FaveBizAPI.post(`/v1/company_managers`, params).then(res => res);
